// Small badges shared by the Sales Orders table and its hover cards: fee METHOD (charged / absorbed / pass-through) and the TERMS pair (payment method + delivery mode).
// Tones are the foundations badge tones (.chip good | info | warn | mut). Words live in the sales namespace (so.feeMethod.*, so.mode.*, so.sub.*): one place each.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { termsOf } from './soModel.mjs';

const METHOD_TONE = { charge: 'info', absorb: 'warn', passThrough: 'mut' };

export function FeeMethodBadge({ method, title }) {
  const { t } = useTranslation('sales');
  return <span className={`chip ${METHOD_TONE[method] || 'mut'}`} title={title || t(`so.feeMethod.tip_${method}`, { defaultValue: '' })} data-testid={`fee-method-${method}`}>{t(`so.feeMethod.${method}`, { defaultValue: method })}</span>;
}

// one small badge per method present on the order; the amounts stay in the Fees hover
export function FeeMethods({ r }) {
  const list = Array.isArray(r.fees_by_method) ? r.fees_by_method : [];
  if (!list.length) return null;
  return <span className="fm-wrap">{list.map(m => <FeeMethodBadge key={m.method} method={m.method} />)}</span>;
}

// payment method badge: Cash (good) | Credit 30 d (warn) | Credit (mut); delivery mode badge: Direct | On delivery (info), word in one place (so.mode.*)
export function TermsBadges({ r }) {
  const { t } = useTranslation('sales'); const tm = termsOf(r), mode = r.delivery_mode;
  if (!tm && !mode) return null;
  return (
    <span className="tm-wrap" data-testid="terms-badges">
      {tm && (tm.cash
        ? <span className="chip good" title={t('so.sub.cashTip')}>{t('so.sub.cash')}</span>
        : <span className={`chip ${tm.days != null ? 'warn' : 'mut'}`} title={t('so.sub.creditTip')}>{tm.days != null ? t('so.sub.credit', { n: tm.days }) : t('so.sub.creditNoDays')}</span>)}
      {mode && <span className="chip info" title={t(`so.mode.tip_${mode}`, { defaultValue: '' })} data-testid={`mode-${mode}`}>{t(`so.mode.${mode}`, { defaultValue: mode })}</span>}
    </span>
  );
}
